/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsPress: {
  name: 'press';
  data: string;
} = {
  name: 'press',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 10a6 6 0 1 1 12 0 6 6 0 0 1-12 0Zm14 0a8.001 8.001 0 0 1-7 7.938V20h8a1 1 0 1 1 0 2H3a1 1 0 1 1 0-2h8v-2.062A8.001 8.001 0 0 1 12 2a8 8 0 0 1 8 8Zm-4.293-2.293a1 1 0 0 0-1.414-1.414l-3 3a1 1 0 0 0 1.414 1.414l3-3Z" fill="currentColor"/></svg>`,
};
